import { render } from "./AboutDialog.vue?vue&type=template&id=5ef1633d"
import script from "./AboutDialog.vue?vue&type=script&lang=js"
export * from "./AboutDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__